/** Copyright © 2013-2021 DataYes, All Rights Reserved. */

import { RRP_WECHAT_ROOT } from '../utils/config';
import http from '../utils/http';

const { get, post, put, delete: d } = http;
const wechatPublicRoot = `${RRP_WECHAT_ROOT}/web/whitelist`;

const API_URL: Record<
  string,
  {
    method: string;
    url: string;
  }
> = {
  login: {
    method: 'POST',
    url: '/usermaster/authenticate/web.json',
  },
  logout: {
    method: 'GET',
    url: '/usermaster/logout.json',
  },
  getCaptchaSlide: {
    method: 'GET',
    url: '/usermaster/slider.json',
  },
  checkCaptchaSlide: {
    method: 'POST',
    url: '/usermaster/slider/check.json',
  },
  sendSms: {
    method: 'POST',
    url: '/usermaster/slider/sms/web.json',
  },
  getWechatLogin: {
    method: 'GET',
    url: '/usermaster/wechat/login.json',
  },
  getWeiboLogin: {
    method: 'GET',
    url: '/usermaster/weibo/login.json',
  },
  // 云平台已把注册修改为和登录相同的接口
  register: {
    method: 'POST',
    url: '/usermaster/authenticate/web.json',
  },
  refreshLogin: {
    method: 'GET',
    url: '/usermaster/identity/nrrp.json',
  },
};

const API: any = {};
Object.keys(API_URL).forEach((key) => {
  const item = API_URL[key];

  switch (item.method) {
    case 'GET':
      API[key] = (params: any) => get(item.url, params, {});
      break;
    case 'POST':
      API[key] = (params: any) => post(item.url, params, {});
      break;
    case 'PUT':
      API[key] = (params: any) => put(item.url, params, {});
      break;
    case 'DELETE':
      API[key] = (params: any) => d(item.url, params, {});
      break;
    default:
      API[key] = (params: any) => get(item.url, params, {});
  }
});

// 使用rrp自己封装的api方法
const wechatPublicApis = {
  getWechatPublicQR: () => get(`${wechatPublicRoot}/wechat/login/qrCode`, {}, {}),
  getWechatPublicLogin: (ticket: string) =>
    get(`${wechatPublicRoot}/wechat/login/status`, { rrpLoginToken: ticket }, {}),
};

export default {
  ...API,
  ...wechatPublicApis,
};
